import toast from "react-hot-toast";
import * as api from "../Api";
import { errorMessage, loadFailed } from "../utils/errorMessage";

// create a  new asset
export const getCategory = () => async (dispatch) => {
  try {
    const { data } = await api.fetchCategory();
    dispatch({ type: "FETCH_ALL", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};

export const createCompanyCategory = (postData) => async (dispatch) => {
  let creatingIdCatId;
  try {
    creatingIdCatId = toast.loading("Creating Category...");
    const { data } = await api.CompanyCategory(postData);
    dispatch({ type: "CREATE_CATEGORY", payload: data });
    toast.remove(creatingIdCatId);
    toast.success("Category created successfully");
  } catch (error) {
    toast.remove(creatingIdCatId);
    toast.error(errorMessage(error));
  }
};

export const deleteCompanyCategory = (id) => async (dispatch) => {
  let creatingIdCatId;
  try {
    creatingIdCatId = toast.loading("Deleting Category...");
    await api.deleteCompanyCategory(id);
    dispatch({ type: "DELETE_CATEGORY", payload: id });
    toast.remove(creatingIdCatId);
    toast.success("Category deleted successfully");
  } catch (error) {
    toast.remove(creatingIdCatId);
    toast.error(errorMessage(error));
  }
};

export const updateCompanyCategory = (id, postData) => async (dispatch) => {
  let creatingIdCatId;
  try {
    creatingIdCatId = toast.loading("Updating Category...");
    const { data } = await api.updateCompanyCategory(id, postData);

    dispatch({ type: "UPDATE_CATEGORY", payload: data });
    toast.remove(creatingIdCatId);
    toast.success("Category updated successfully");
  } catch (error) {
    toast.remove(creatingIdCatId);
    toast.error(errorMessage(error));
  }
};
